const copyToClipboard = {
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText)
      {
        return navigator.clipboard.writeText(text)
          .catch(() => this.copyToClipboardFallback(text));
      }

      return this.copyToClipboardFallback(text);
    },
    copyToClipboardFallback(text) {
      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          if (document.execCommand('copy'))
          {
            resolve();
          }
          else
          {
            reject(new Error('Copy command was not successful'));
          }
        } catch (err) {
          reject(err);
        } finally {
          document.body.removeChild(textarea);
          window.getSelection().removeAllRanges();
        }
      });
    },
  },
};

export default copyToClipboard;



// WEBPACK FOOTER //
// ./src/js/mixins/copyToClipboard.js